import BaseService from "../BaseService";
import _ from "lodash";

class VoucherService extends BaseService {
    list = async ({ info } = {}) => {
        var data = await this._api.post("/voucher/list",{info});
        return data;
    };


    create = async (voucher) => {
        var data = await this._api.post("/voucher/create", voucher);
        return data;
    };

    get = async (id) => {
        var data = await this._api.post("/voucher/get", { id });
        return data;
    };


    delete = async (id) => {
        var data = await this._api.post("/voucher/delete", { id });
        return data;
    };









}
export default VoucherService;
